import returnVendor from '@/api/stock/return-to-vendor'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  branch_id: [],
  status: [],
  vendor: [],
  dateRange: [moment().add(-7, 'days').format('DD-MM-YYYY'), moment().format('DD-MM-YYYY')]
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_RANGE(state, date) {
    state.dateRange = date
  },
  SET_RETURN_STATUS(state, data) {
    state.status = data
  },
  SET_VENDOR_LIST(state, data) {
    state.vendor = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search,
          date_between: _.join(context.state.dateRange, ',')
        }
      },
      attrubutes
    )
    return returnVendor.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return returnVendor.store(data)
  },
  getStockInByNumber(context, data) {
    return returnVendor.stockInByNumber(data)
  },
  update(context, { id, data }) {
    return returnVendor.update(id, data)
  },
  destroy(context, id) {
    return returnVendor.destroy(id)
  },
  setRefundReceived(context, returnToVendorId) {
    return returnVendor.setRefundReceived(returnToVendorId)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await returnVendor.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  findBySerial(context, serialNumber) {
    return returnVendor.findBySerial(serialNumber)
  },
  async fetchResource(context) {
    let var_status = await returnVendor.status()
    context.commit('SET_RETURN_STATUS', var_status.data)
    let var_vendor = await returnVendor.vendor()
    context.commit('SET_VENDOR_LIST', var_vendor.data)
  },
  toPdf(context, id) {
    return returnVendor.toPdf(id)
  },
}
